export const INSTRUMENTATION_SCOPE_NAME = '@atlas/observability';
export const ATTR_USER_ID = 'usr.id';
export const ATTR_DEPLOYMENT_ENVIRONMENT = 'deployment.environment';
export const CONSOLE_PREFIX = '[observability]';
